import * as yup from 'yup';

export const publicSettingsValidationSchema = {
  value: yup.string().required('Value is required!'),
  description: yup.string().required('Description is required!')
};
